import { Injectable } from '@angular/core';
import * as Highcharts from 'highcharts';

@Injectable({
	providedIn: 'root'
})
export class ChartHelperService {
	constructor() { }

	toggleDownloadMenu(currentIndex: number, activeIndex: number | null): number | null {
		return currentIndex === activeIndex ? null : currentIndex;
	}

	downloadCSV(chart: Highcharts.Chart | undefined): void {
		chart?.downloadCSV();
	}

	downloadXLS(chart: Highcharts.Chart | undefined): void {
		chart?.downloadXLS();
	}

	toggleFullScreen(chart: Highcharts.Chart | undefined): void {
		chart?.fullscreen?.toggle();
	}

	viewChartData(chart: Highcharts.Chart, index: number): void {
		const chartContainer = document.getElementById(`chart-container-${index}`) as HTMLElement;
		if (!chart || !chartContainer) return;

		if (!chartContainer.classList.contains('hide-container')) {
			chart.viewData();

			const tableContainer = chartContainer.parentNode?.children[1];
			if (!tableContainer) return;

			const button = document.createElement("button");
			button.classList.add("close-icon");
			button.setAttribute("title", "Close");

			const matIcon = document.createElement("mat-icon");
			matIcon.classList.add("mat-icon", "notranslate", "material-icons-outlined", "mat-icon-no-color");
			matIcon.setAttribute("role", "img");
			matIcon.setAttribute("aria-hidden", "true");
			matIcon.textContent = "close";
			button.appendChild(matIcon);

			button.addEventListener("click", () => {
				chart.hideData();
				chartContainer.classList.remove("hide-container");
				tableContainer.classList.remove("show-table");
				button.remove();
			});

			const table = tableContainer.children[1];
			const wrapper = document.createElement("div");
			wrapper.classList.add("graph-data");

			table?.parentNode?.replaceChild(wrapper, table);
			// wrapper.appendChild(table);
			tableContainer.prepend(button);
			tableContainer.classList.add("show-table");

			chartContainer.classList.add("hide-container");
		}
	}
}
